import React from 'react';

import { VisuallyHidden } from '@depop/web-ui-kit/VisuallyHidden';
import { clsx } from 'clsx';

import styles from './styles.module.css';

type CarouselIndicatorProps = {
  currentSlide: number;
  index: number;
  slides: React.ReactNode[];
};

export function CarouselIndicators({
  currentSlide,
  index,
  slides,
}: CarouselIndicatorProps) {
  return (
    <div className={styles.dotsContainer}>
      <VisuallyHidden>
        Slide {currentSlide} of {slides.length}
      </VisuallyHidden>
      {slides.map((_item, currentIndex) => (
        <div
          className={clsx(
            styles.dot,
            currentIndex === index && styles.dotActive
          )}
          key={`image-dot-${currentIndex}`}
        />
      ))}
    </div>
  );
}
